import React, { Component } from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import IconButton from 'material-ui/IconButton';
import ActionHome from 'material-ui/svg-icons/social/person';
import history from '../history';

class Intro extends Component {

    constructor(props) {
        super(props);

        this.state = {mentor: false, mentee: false};
    }

    styles = {
        h1 : {
            textAlign: 'center',
            paddingTop: '5%'
        },
        container: {
            display: 'grid',
            gridTemplateColumns: 'auto auto',
            margin: '30vh auto 0 29%',
        },
        largeIcon: {
            width: 48,
            height: 48
        },
        span: {
            padding: '10px'
        }
    };

    render() {

        const { isAuthenticated } = this.props.auth;
        const { mentor, mentee } = this.state;

        if (isAuthenticated()) {
            history.replace('/mentors');
        }

        if (mentee) {
            window.localStorage.setItem("isMentee", true);
            this.props.auth.login();
        }

        if (mentor) {
            window.localStorage.setItem("isMentee", false);
            this.props.auth.login();
        }

        return (
                <MuiThemeProvider>
                    <div>
                        <h1 style={this.styles.h1}>I AM A</h1>
                        <div class="container" style={this.styles.container}>
                            <div class="item">
                                <IconButton onClick={() => this.setState({mentee: true, mentor: false})} iconStyle={this.styles.largeIcon}>
                                    <ActionHome />
                                </IconButton>
                            </div>
                            <div class="item">
                                <IconButton onClick={() => this.setState({mentor: true, mentee: false})} iconStyle={this.styles.largeIcon}>
                                    <ActionHome />
                                </IconButton>
                            </div>
                            <span style={this.styles.span}>Mentee</span>
                            <span style={this.styles.span}>Mentor</span>
                        </div>
                    </div>
                </MuiThemeProvider>
        );
    }
}

export default Intro;


// WEBPACK FOOTER //
// ./src/components/Intro.js